module.exports = __webpack_public_path__ + "static/media/LogikBomb.202af2a8.png";